import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import ShopifyAuth from "../pages/ShopifyAuth";
import SetPassword from "../pages/SetPassword";

import VerifyEmail from "../pages/VerifyEmail";
import ResetPassword from "../pages/ResetPassword";
import ShopifyAppInstall from "../pages/ShopifyAppInstall";
import SetPasswordForShopifyStoreOwner from "../pages/SetPasswordForShopifyStoreOwner";
import NewSignIn from "../pages/NewSignIn";
import NewForgotPassword from "../pages/NewForgotPassword";
import NewSetPassword from "../pages/NewSetPassword";

// New stores sign up by installing the Shopify app; affiliates are linked by an admin.
const SHOPIFY_APP = "https://apps.shopify.com/u-send";
function SignUpRedirect() {
  useEffect(() => {
    window.location.replace(SHOPIFY_APP);
  }, []);
  return null;
}

export default function AuthRoutes() {
  return (
    <Routes>
      <Route exact path="/*">
        <Route path="" element={<NewSignIn />} />
        <Route path="signin" element={<NewSignIn />} />
        {/* <Route path="signup" element={<Signup />} /> */}
        <Route path="signup" element={<SignUpRedirect />} />
        <Route path="verify-email/*" element={<VerifyEmail />} />
        {/* <Route path="forgot-password" element={<ForgotPassword />} /> */}
        <Route path="forgot-password" element={<NewForgotPassword />} />
        <Route path="set-password/*" element={<NewSetPassword />} />
        <Route path="set-password-store-owner/*" element={<SetPasswordForShopifyStoreOwner />} />
        <Route path="reset-password/*" element={<ResetPassword />} />
        <Route path="auth" element={<ShopifyAuth />} />
        <Route path="install" element={<ShopifyAppInstall/>} />
      </Route>
    </Routes>
  );
}


